"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLEmpty = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const useDVL_1 = __importDefault(require("../useDVL"));
exports.DVLEmpty = react_1.default.memo(() => {
    const { notFoundText = lib_i18n_1.default.t('no-items-found') } = (0, useDVL_1.default)();
    return (react_1.default.createElement(Horizontal_1.default, { padding: true, stretch: true },
        react_1.default.createElement(Pane_1.default, { grow: true }),
        react_1.default.createElement(Vertical_1.default, { centered: true, gutter: true },
            react_1.default.createElement("img", { style: { minHeight: 200, maxHeight: 200 }, alt: "No data found", src: "/assets/images/empty-desk.svg" }),
            react_1.default.createElement(Text_1.default, { variant: "h1" }, notFoundText)),
        react_1.default.createElement(Pane_1.default, { grow: true })));
});
exports.default = exports.DVLEmpty;
